export const cleanStringFromHTMLTags = (string) => {
  let div = document.createElement("div");
  div.innerHTML = string;
  return div.textContent || div.innerText || "";
};
